import { LandingCompanyNameEnum } from "../enums";

export const LANDING_WORKERS_TYPE_IDS = {
  [LandingCompanyNameEnum.Clal]: {
    employee: 835, // prod id is 835
    contractor: 836, // prod id is 835
  },
} as const;
